import React from 'react';
import PGAlogo from '../assets/pga_bharat.png';
import './HomePage.css';
import { ArrowRight, Mail, MapPin } from 'lucide-react';

export default function HomePage({ onContactClick }) {
  return (
    <>
      <div className="home-page">
        {/* Ambient glow orb */}
        <div className="glow-circle" />

        <div className="hero-content">

          {/* Logo */}
          <div className="logo-wrap">
            <div className="logo-glow" />
            <img src={PGAlogo} alt="PGA Bharat Logo" className="hero-logo" />
          </div>

          {/* Hero Text */}
          <div className="hero-text">
            <h1 className="hero-title">PGA BHARAT</h1>
            <p className="hero-subtitle">Elevating Golf Excellence in India</p>
            <div className="divider" />
          </div>

          {/* CTA */}
          <button className="contact-btn" onClick={onContactClick}>
            Contact Us
            <ArrowRight size={20} strokeWidth={2.5} />
          </button>

          {/* Info Cards */}
          <div className="info-cards">
            <div className="info-card">
              <div className="info-icon email-icon">
                <Mail size={22} strokeWidth={2} color="white" />
              </div>
              <div className="info-details">
                <span className="info-label">Email Us</span>
                <span className="info-value">pga.india@aivot.ai</span>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon location-icon">
                <MapPin size={22} strokeWidth={2} color="white" />
              </div>
              <div className="info-details">
                <span className="info-label">Location</span>
                <span className="info-value">India</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}